import React from 'react';
// import { translate } from 'react-i18next';
import {Icon} from '../../Common/Icon';
// import { Link } from 'react-router-dom';
import cx from '../../../styles';
// import './style.css';


const Breadcrumbs = ({links = []}) => {
    return (
        <div className={cx("breadcrumbs-wrapper")}>
            {
                links.map((link, i) => {
                    return <span key={i}>
                        <a href={link.location}>{link.label}</a>
                        { links.length != i+1 && <span className={cx("chevron-right-icon")}> <Icon name="breadcrumbs-icon" color="#ccc" /> </span>}
                    </span>
                })
            }
        </div>
    );
}


export default Breadcrumbs;